<template>
  <div>
    <a-row :gutter="24" type="flex">
      <!-- Authors Table Column -->
      <a-col :span="24" class="mb-24">
        <!-- Authors Table Card -->
        <AchievementTable :loading="loading" :data="tableData" :columns="tableColumns" :currentPage="currentPage"
          :countObjData="countObjData" :perPage="perPage" :optionNationality="optionNationality"
          :optionProgram="optionProgram" :optionMajor="optionMajor" :optionYear="optionYear" @changepage="onChangePage"
          @search="onSearchAchievement" :loadBtnExport="loadBtnExport" @exportAlumniAwards="exportAlumniAwards">
        </AchievementTable>
        <!-- / Authors Table Card -->
      </a-col>

      <!-- / Authors Table Column -->
    </a-row>
    <!-- / Authors Table -->
  </div>
</template>

<script>
// "Authors" table component.
import AchievementTable from "./AchievementTable";
import _excelReport from "../excel-report/headerexcel.js";

// "Authors" table list of columns and their properties.
// fixed: "left", width: 100,
const tableColumns = [
  {
    title: "Date of Receive",
    dataIndex: "date_of_recive",
    scopedSlots: { customRender: "date_of_recive" },
    sorter: true,
    class: "center-colum column-header",
  },
  {
    title: "Name of Award",
    dataIndex: "name_of_award_scholarship",
    scopedSlots: { customRender: "name_of_award_scholarship" },
    class: "center-colum column-header",
  },
  {
    title: "Place",
    dataIndex: "location_and_country",
    scopedSlots: { customRender: "location_and_country" },
    class: "center-colum column-header",
  },
  {
    title: "Organization",
    dataIndex: "organized_by_granted_by",
    scopedSlots: { customRender: "organized_by_granted_by" },
    class: "center-colum column-header",
  },
  {
    title: "Student ID",
    dataIndex: "alumni_profile_detail.student_id",
    scopedSlots: { customRender: "alumni_profile_detail.student_id" },
    sorter: true,
    class: "center-colum column-header",
  },
  {
    title: "Major",
    dataIndex: "alumni_profile_detail.major_detail.name_eng",
    scopedSlots: {
      customRender: "alumni_profile_detail.major_detail.name_eng",
    },
    class: "center-colum column-header",
  },
  {
    title: "Academic Title",
    dataIndex: "academic_title",
    scopedSlots: { customRender: "academic_title" },
    class: "center-colum column-header",
  },
  {
    title: "Title",
    dataIndex: "alumni_title",
    scopedSlots: { customRender: "alumni_title" },
    class: "center-colum column-header",
  },
  {
    title: "Name Surname",
    dataIndex: "alumni_name",
    scopedSlots: { customRender: "alumni_name" },
    class: "center-colum column-header",
  },
  {
    title: "Graduate Year",
    dataIndex: "grad_year",
    scopedSlots: { customRender: "grad_year" },
    class: "center-colum column-header",
  },
  {
    title: "Type of Award",
    dataIndex: "type_award",
    scopedSlots: { customRender: "type_award" },
    class: "center-colum column-header",
  },
];

export default {
  components: {
    AchievementTable,
  },
  data() {
    return {
      // Associating "Authors" table data with its corresponding property.
      tableData: [],
      // Associating "Authors" table columns with its corresponding property.
      tableColumns: tableColumns,
      loading: false,
      // pagination
      perPage: 10,
      countObjData: 0,
      currentPage: 1,
      offset: 0,
      // option selected
      optionNationality: [],
      optionProgram: [],
      optionMajor: [],
      optionYear: [],
      //
      dataFilter: {},
      // export data : _excelReport
      loadBtnExport: false,
      headExcelAlumniData: _excelReport.reportC,
      dataExcel: [],
    };
  },
  mounted() {
    this.setOptionYear();
    this.getDataOption();
    this.getDataAwards();
  },
  methods: {
    onChangePage(...args) {
      this.currentPage = args[0].currentPage;
      this.offset = args[0].currentPage;
      this.getDataAwards();
    },
    onSearchAchievement(...args) {
      this.dataFilter = Object.assign({}, args[0].dataQuery);
      this.currentPage = 1;
      this.offset = 0;
      this.getDataAwards();
    },
    changeFormatDateToFisicalYear(typeDate, yearStart, yearEnd) {
      if (yearStart && yearEnd) {
        if (typeDate == 'Start') {
          return (parseInt(yearStart)).toString() + '-10-01'
        } else {
          if (yearStart != yearEnd) return (parseInt(yearEnd + 1)).toString() + '-09-30'
          else return (parseInt(yearEnd + 1)).toString() + '-09-30'
        }
      } else {
        return ''
      }
    },
    async getDataAwards() {
      this.tableData = [];
      this.loading = true;
      let url = "";
      try {
        if (Object.keys(this.dataFilter).length != 0) {
          url = `/student_affair/alumni-award/?limit=${this.perPage}&offset=${this.offset}&search=${this.dataFilter.searchText}&alumni_profile__membership_id__isnull=${
            this.dataFilter.member?
            (this.dataFilter.member == "member" ? false : true)
            : ""
          }&alumni_profile__nationality=${this.dataFilter.nationnality}&alumni_profile__program_code=${this.dataFilter.program}&alumni_profile__major=${this.dataFilter.major}&type_award=${this.dataFilter.typeAwards}&date_of_recive__gte=${this.changeFormatDateToFisicalYear('Start', this.dataFilter.fisicalStart, this.dataFilter.fisicalEnd)}&date_of_recive__lte=${this.changeFormatDateToFisicalYear('End', this.dataFilter.fisicalStart, this.dataFilter.fisicalEnd)}&alumni_profile__graduate_year__gte=${this.dataFilter.yearStart}&alumni_profile__graduate_year__lte=${this.dataFilter.yearEnd}`;
        } else {
          url = `/student_affair/alumni-award/?limit=${this.perPage}&offset=${this.offset}`;
        }
        const res = await this.$http.get(url);
        if (res.status === 200) {
          this.tableData = res.data.results.map((item) => ({ ...item }));
          this.countObjData = res.data.count;
          this.offset = 0;
          this.loading = false;
        } else {
          throw { res };
        }
      } catch (error) {
        this.tableData = [];
        this.$notification['error']({
          message: function (h) {
            return h("div", [
            h("strong", { class: "" }, `Failed to connect to the API`),
            ]);
          },
          description:
          `Error ${error.response.status} : /student_affair/alumni-award/`,
        });
        this.loading = false;
      }
    },
    setOptionYear() {
      this.optionYear = [];
      for (let y = 0; y <= 200; y++) {
        let listY = parseInt(this.moment().format("YYYY") - y);
        this.optionYear.push(listY);
      }
    },
    async getDataOption() {
      const fetchNationality = await this.$http.get(
        `/student_affair/nationality/`
      );
      const fetchProgram = await this.$http.get(
        `/student_affair/program-code/`
      );
      const fetchMajor = await this.$http.get(`/student_affair/major/`);
      Promise.all([fetchNationality, fetchProgram, fetchMajor])
        .then((response) => {
          return Promise.all(response.map((r) => r.data));
        })
        .then(([listA, listB, listC]) => {
          this.optionNationality = listA.map((item) => {
            return {
              id: item.id,
              text: `${item.name_eng} ${item.name_thai}`,
              value: item.id,
            };
          });
          this.optionProgram = listB.map((item) => {
            return {
              id: item.id,
              text: item.name_eng,
              value: item.id,
            };
          });
          this.optionMajor = listC.map((item) => {
            return {
              id: item.id,
              text: item.name_eng,
              value: item.id,
            };
          });
        })
        .catch((error) => {
          this.$notification['error']({
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Failed to connect to the API`),
            ]);
          },
          description:
          `Error ${error.response.status} : /student_affair/alumni-profile/`,
        });
        });
    },
    async exportAlumniAwards() {
      this.loadBtnExport = true;
      this.dataExcel = [];

      if (this.tableData.length > 0) {
        this.dataExcel = this.tableData.map((item) => ({
          A: item.alumni_profile,
          B: item.id,
          C: `${_excelReport.printFormatData(
            item.alumni_profile_detail.muicaa_member,
            "string",
            ""
          )}`,
          D: `${_excelReport.printFormatData(
            item.alumni_profile_detail.muicaa_steering_committee,
            "string",
            ""
          )}`,
          E: `${_excelReport.printFormatData(
            item.alumni_profile_detail.student_id,
            "string",
            ""
          )}`,
          F: `${_excelReport.printFormatData(
            item.alumni_profile_detail.name_detail.slice().reverse()[0],
            "Obj",
            "academic_title_detail"
          )}`,
          G: `${_excelReport.printFormatData(
            item.alumni_profile_detail.name_detail.slice().reverse()[0],
            "Obj",
            "title_name_detail"
          )}`,
          H: `${_excelReport.printFormatData(
            item.alumni_profile_detail.name_detail.slice().reverse()[0],
            "Obj",
            "eng_first_name"
          )}`,
          I: `${_excelReport.printFormatData(
            item.alumni_profile_detail.name_detail.slice().reverse()[0],
            "Obj",
            "eng_middle_name"
          )}`,
          J: `${_excelReport.printFormatData(
            item.alumni_profile_detail.name_detail.slice().reverse()[0],
            "Obj",
            "eng_last_name"
          )}`,
          K: `${_excelReport.printFormatData(
            item.date_of_recive,
            "string",
            ""
          )}`,
          L: `${_excelReport.printFormatData(
            item.name_of_award_scholarship,
            "string",
            ""
          )}`,
          M: `${_excelReport.printFormatData(
            item.location_and_country,
            "string",
            ""
          )}`,
          N: `${_excelReport.printFormatData(
            item.organized_by_granted_by,
            "string",
            ""
          )}`,
          O: `${_excelReport.printFormatData(
            item.alumni_profile_detail.graduate_year,
            "string",
            ""
          )}`,
          P: `${_excelReport.printFormatData(item.type_award, "string", "")}`,
        }));
        // create excle file
        const wb = this.XLSX.utils.book_new();
        const data = this.XLSX.utils.json_to_sheet(
          this.headExcelAlumniData.concat(this.dataExcel),
          {
            header: _excelReport.mainExcel,
            skipHeader: true,
          }
        );
        this.XLSX.utils.book_append_sheet(wb, data, "List-alumni-awards");
        this.XLSX.writeFile(wb, "Alumni_Awards.xlsx");
        this.loadBtnExport = false;
      } else {
        this.loadBtnExport = false;
        this.$notification['error']({
          message: function (h) {
            return h("div", [
            h("strong", { class: "" }, `Can't export to excel file`),
            ]);
          },
          description:
          `Data table not fond.`,
        });
      }
    },
  },
};
</script>

<style>
.center-colum {
  text-align: center !important;
  font-weight: 700 !important;
  font-size: 14px;
}

th.column-header {
  background-color: #453c67 !important;
  color: #ffffff !important;
}

th.column-header-sub {
  background-color: #b7c4cf !important;
  color: #000000 !important;
}
</style>